import React, { DOMAttributes } from 'react';

type InnerHTMLProps = {
  dangerouslySetInnerHTML?: DOMAttributes<Element>['dangerouslySetInnerHTML'];
};

export interface ISafeHTMLProps {
  sanitizedHtml: string;
  className?: string;
  component?:
    | React.ComponentType<React.PropsWithChildren<InnerHTMLProps>>
    | keyof JSX.IntrinsicElements;
  children?: React.ReactElement<InnerHTMLProps>;
}

// Use when you know that the html is safe for the client to display. i.e. sanitized server-side
export const SafeHTML = ({
  sanitizedHtml,
  component,
  className,
  children,
}: ISafeHTMLProps) => {
  const props = {
    dangerouslySetInnerHTML: { __html: sanitizedHtml },
    className,
  };

  if (component) {
    return React.createElement(component, props);
  }

  if (children) {
    return React.cloneElement(children, props);
  }

  return null;
};
